import { defineMessages } from 'react-intl';

export default defineMessages({
	searchPlaceholder: {
		defaultMessage: 'Search for services',
		description: 'Placeholder for service picker field to advise the user to search for services',
		id: 'cv.request.create.form.multiservicepickerv2.search',
	},
	noOptions: {
		defaultMessage: 'No options',
		description:
			'Text that appears in the dropdown for the service picker if there are no services to select',
		id: 'cv.request.create.form.multiservicepickerv2.no.options',
	},
});
